import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from "@angular/common";
import {TimeUtility} from "../time.utility";

@Pipe({
  name: 'readableDate'
})
export class ReadableDatePipe implements PipeTransform {

  transform(date: Date | string | null | undefined, socialDate: boolean = false): string | null {
    if (date == null) return null
    let format = 'MMM dd, yyyy hh:mm a'
    if (!socialDate) {
      return new DatePipe('en').transform(date, format)
    }
    let duration = TimeUtility.getDuration(new Date(), new Date(date))
    if (duration > 43200000) return new DatePipe('en').transform(date, format)
    return TimeUtility.msToReadableTime(duration, false);
  }

}
